import styled from "styled-components";
export const Styles = styled.div`
  #trainerSection {
    position: relative;
    margin-top: 100px;
    margin-bottom: 200px;
  }
  #trainerSection .background {
    position: absolute;
    top: -40px;
    height: 180%;
    left: -200px;
    transform: rotate(20deg);
  }
  #trainerSection .react {
    position: absolute;
    height: 65%;
    right: -120px;
  }
  #trainerSection .tag {
    position: absolute;
    top: -80px;
    left: 0;
    height: 40%;
  }
  #trainerSection .container {
    text-align: center;
  }
  #trainerSection .swiper .swiper-button-prev {
    right: 10.8%;
  }
  #trainerSection .swiper .swiper-button-next {
    left: 10.8%;
  }
  #trainerSection .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #trainerSection .item-content {
    background: #fff;
    position: relative;
    display: flex;
    justify-content: space-between;
    border: 1px solid #70707019;
    border-radius: 25px;
    width: 75%;
  }
  #trainerSection .item-content .item-img {
    width: 30%;
    border-radius: 25px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #trainerSection .item-content .item-img img {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }
  #trainerSection .item-content .item-data {
    padding: 30px;
    position: relative;
    width: 70%;
    color: var(--dark-purple);
  }
  #trainerSection .item-content .item-data .item-info {
    margin-top: 20px;
    text-align: start;
    font-size: 14px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  #trainerSection .item-content .item-data .item-info .more {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #trainerSection .item-content .item-data .item-info .more .btn {
    width: 120px !important;
  }
  #trainerSection .item-content .item-data .item-info .item-job-title {
    margin-bottom: 10px;
  }
  .dots{
    font-size: 15px;
  }
  @media (max-width: 1080px) {
    #trainerSection .swiper {
      padding-inline: 20px;
    }
    #trainerSection .item-content {
      width: 100%;
    }
    #trainerSection .swiper .swiper-button-prev {
      right: 0px;
    }
    #trainerSection .swiper .swiper-button-next {
      left: 0px;
    }
    #trainerSection .item-content .item-data .item-info {
      font-size: 13px;
    }
  }
  @media (max-width: 768px) {
    #trainerSection .background {
      position: absolute;
      top: 40%;
      height: 100%;
    }
    #trainerSection .react {
      height: 45%;
    }
    #trainerSection .tag {
      height: 30%;
      transform: rotate(-15deg);
    }
    #trainerSection .item-content {
      margin-top: 150px;
      padding-top: 120px;
      height: 380px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    #trainerSection .item-content .item-img {
      position: absolute;
      top: -25%;
      left: 50%;
      transform: translateX(-50%);
      width: 200px;
      height: 200px;
    }
    #trainerSection .item-content .item-data {
      font-size: 13px;
      padding: 10px;
      padding-inline-start: 0;
      width: 80%;
    }
    #trainerSection .item-content .item-data .item-info {
      font-size: 13px;
      margin-top: 0;
      text-align: center;
      height: 240px;
    }
    .item-title{
      font-size: 15px;
      font-weight: bold;
    }
    .item-description {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
    }
    #trainerSection .swiper .swiper-button-prev {
      top: 75%;
    }
    #trainerSection .swiper .swiper-button-next {
      top: 75%;
    }
  }
`;
